<template>
  <div class="flex flex-col-reverse md:flex-row">
    <div
      class="md:flex flex-col justify-between bg-primary md:w-196 px-8 py-4 md:mr-4 min-h-screen"
    >
      <div class="flex flex-col items-center">
        <a href="https://healthycmu.com/">
          <h1 class="text-4xl text-white text-center mt-8 md:mt-24 mb-8">
            CMU i-Health
          </h1>
        </a>

        <p class="text-center text-base font-light text-white mb-12">
          มหาวิทยาลัยเชียงใหม่เล็งเห็นปัญหาด้านสุขภาพของบุคลากรวัยทำงาน
          จึงพัฒนาระบบ CMU i-Health
          เพื่อใช้ประเมินความเสี่ยงด้านสุขภาพของบุคลากรมหาวิทยาลัย
          เพื่อส่งเสริมการสร้างเสริมสุขภาพสำหรับบุคลากรในมหาวิทยาลัยเชียงใหม่ให้มีสุขภาพที่ดี
          สามารถดูแลตนเอง ลดภาวะเสี่ยงทางสุขภาพ
          และป้องกันโรคไม่ติดต่อเรื้อรังที่พบบ่อยในวัยทำงาน
          นำไปสู่การมีคุณภาพชีวิตที่ดีขึ้น
          เพิ่มประสิทธิภาพการทำงานและเตรียมความพร้อมการเข้าสู่วัยเกษียณได้อย่างเหมาะสม
        </p>
      </div>

      <img class="self-end" src="@/assets/landing-background.png" alt />
    </div>

    <div class="flex flex-col justify-between w-full">
      <div class="flex flex-col items-center justify-center mt-12 md:mt-32">
        <img src="@/assets/cmu-logo.png" alt class="w-32 mb-4" />

        <h1 class="text-2xl text-primary text-center mt-8">เข้าสู่ระบบ</h1>

        <tabs class="mb-16 mx-6 md:mx-0 mt-12">
          <tab title="เข้าสู่ระบบด้วย CMU Account">
            <div
              class="bg-white px-4 shadow:md sm:rounded-lg sm:px-10 w-full sm:w-128"
            >
              <div v-if="!liff.isInClient()" class="mt-12">
                <span class="block w-full rounded-md shadow-sm">
                  <button
                    @click="loginWithCmu"
                    class="bg-primary border border-primary px-4 py-2 rounded mx-auto my-0 w-full mt-6"
                  >
                    <p class="text-white text-center">
                      เข้าสู่ระบบด้วย CMU IT Account
                    </p>
                  </button>
                </span>
              </div>

              <div v-else class="mt-6">
                <span class="block w-full rounded-md shadow-sm">
                  <button
                    @click="loginWithCmu"
                    class="bg-green-400 px-4 py-2 rounded mx-auto my-0 w-full"
                  >
                    <p class="text-white text-center">เข้าสู่ระบบด้วย Line</p>
                  </button>
                </span>
              </div>
            </div>
          </tab>

          <tab title="เข้าสู่ระบบด้วยอีเมลล์และรหัสผ่าน">
            <div
              class="bg-white py-8 px-4 shadow:md sm:rounded-lg sm:px-10 w-full sm:w-128"
            >
              <form action="#" method="POST">
                <div>
                  <label
                    for="email"
                    class="block text-sm font-medium leading-5 text-gray-700"
                  >
                    อีเมลล์
                  </label>
                  <div class="mt-1 rounded-md shadow-sm">
                    <input
                      v-model="email"
                      id="email"
                      type="email"
                      required
                      class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>
                </div>

                <div class="mt-6">
                  <label
                    for="password"
                    class="block text-sm font-medium leading-5 text-gray-700"
                  >
                    รหัสผ่าน
                  </label>
                  <div class="mt-1 rounded-md shadow-sm">
                    <input
                      v-model="password"
                      id="password"
                      type="password"
                      required
                      class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>
                </div>

                <div class="mt-6">
                  <span class="block w-full rounded-md shadow-sm">
                    <button
                      @click="login"
                      class="bg-primary px-4 py-2 rounded mx-auto my-0 w-full"
                    >
                      <p class="text-white text-center">เข้าสู่ระบบ</p>
                    </button>
                  </span>
                </div>
              </form>

              <div class="mt-6">
                <div class="relative">
                  <div class="absolute inset-0 flex items-center">
                    <div class="w-full border-t border-gray-300"></div>
                  </div>
                  <div class="relative flex justify-center text-sm leading-5">
                    <span class="px-2 bg-white text-gray-500"> หรือ </span>
                  </div>
                </div>

                <button
                  class="bg-white border border-primary px-4 py-2 rounded mx-auto my-0 w-full mt-6"
                >
                  <router-link to="/register">
                    <p class="text-white text-center text-primary">
                      สร้างบัญชีผู้ใช้งาน
                    </p>
                  </router-link>
                </button>
              </div>
            </div>
          </tab>
        </tabs>

        <!-- <div
          class="bg-white px-4 shadow:md sm:rounded-lg sm:px-10 w-full sm:w-128 mb-24"
        >
          <div class="">
            <span class="block w-full rounded-md shadow-sm">
              <button
                @click="loginWithCmu"
                class="bg-primary border border-primary px-4 py-2 rounded mx-auto my-0 w-full mt-6"
              >
                <p class="text-white text-center">
                  เข้าสู่ระบบด้วย CMU IT Account
                </p>
              </button>
            </span>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<style>
.doodle-bg {
  background: url("~@/assets/landing-login.png") no-repeat;
  background-position: 0;
}
</style>

<script>
import axios from "axios";
import { Tabs, Tab } from "vue-slim-tabs";
import liff from "@line/liff";

export default {
  components: {
    Tabs,
    Tab,
  },
  async created() {
    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/me/profile`,
        headers: {
          authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
        },
      });

      this.$router.replace({ name: "assessment-history.overview" });
    } catch (error) {}

    this.loginWithCmuMobile();
  },
  data() {
    return {
      email: "",
      password: "",

      liff,
    };
  },
  methods: {
    async login(event) {
      event.preventDefault();

      const { email, password } = this;

      let loader = this.$loading.show();

      try {
        const response = await axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_URL}/login`,
          data: {
            email,
            password,
          },
        });

        const { token } = response.data;
        localStorage.setItem("TOKEN", token);

        loader.hide();
        this.$notify({
          type: "success",
          group: "foo",
          title: "เข้าสู่ระบบผู้ใช้สำเร็จ",
          text: "ยินดีต้อนรับ",
        });

        this.$router.push({ path: "/assessments" });

        // if (this.$router.params.from == "admin") {
        //   this.$router.push({ path: "/admin/dashboard" });
        // } else {
        //   this.$router.push({ path: "/assessments" });
        // }
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "error",
          group: "foo",
          title: "เข้าสู่ระบบผู้ใช้ไม่สำเร็จ",
          text: "ลองใหม่อีกครั้ง",
        });
        loader.hide();
      }
    },
    loginWithCmu(event, to = null) {
      event.preventDefault();

      let state = { to };

      let callbackUri = `${process.env.VUE_APP_URL}/callback`;
      state.user = "user";

      if (this.$route.query.from == "admin") {
        state.user = "admin";
      }

      window.location.href = `https://oauth.cmu.ac.th/v1/Authorize.aspx?response_type=code&client_id=N5hb0sT0fjnW2Q99P5CrVbBmw7S3VavyRvbEzATQ&redirect_uri=${callbackUri}&scope=cmuitaccount.basicinfo mishr.self.basicinfo cmuitaccount.personal_id&state=${JSON.stringify(
        state
      )}`;
    },

    async loginWithCmuMobile() {
      const accessToken = this.$route.query.token;

      if (accessToken) {
        let loader = this.$loading.show();

        try {
          const response = await axios({
            method: "POST",
            url: `${process.env.VUE_APP_API_URL}/cmu-account/check?accessToken=${accessToken}`,
          });

          const { token } = response.data;
          localStorage.setItem("TOKEN", token);

          loader.hide();
          this.$notify({
            type: "success",
            group: "foo",
            title: "เข้าสู่ระบบผู้ใช้สำเร็จ",
            text: "ยินดีต้อนรับ",
          });

          this.$router.push({ path: "/assessments" });
        } catch (error) {
          loader.hide();
        }
      }
    },
  },
};
</script>
